
import { useCallback, useLayoutEffect, useRef } from 'react';

import { useDebouncedCallback } from '@datanomik/core-ui';

import { useDeepCompareEffect, useDeepCompareLayoutEffect } from './useDeepCompareEffect';

export const useDebouncedEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef<any>(undefined);
  const effectRef = useRef<any>(undefined);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useDebouncedCallback(() => {
    cleanUp.current = effectRef.current?.();
  }, wait);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(lazyEffect, deps);
  useLayoutEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};

export const useDebouncedDeepCompareEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef<any>(undefined);
  const effectRef = useRef<any>(undefined);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useDebouncedCallback(() => {
    cleanUp.current = effectRef.current?.();
  }, wait);

  useDeepCompareEffect(lazyEffect, deps);
  useDeepCompareEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};

export const useDebouncedDeepCompareLayoutEffect = (effect, deps = [], wait = 150) => {
  const cleanUp = useRef<any>(undefined);
  const effectRef = useRef<any>(undefined);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  effectRef.current = useCallback(effect, deps);

  const lazyEffect = useDebouncedCallback(() => {
    cleanUp.current = effectRef.current?.();
  }, wait);

  useDeepCompareLayoutEffect(lazyEffect, deps);
  useDeepCompareLayoutEffect(() => () => (cleanUp.current instanceof Function ? cleanUp.current() : undefined), []);
};
